import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s20 gap-6 px-5 pb-8 collapse-content active" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center gap-6"
}
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_7 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_8 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_9 = { class: "s7" }
const _hoisted_10 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_11 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_12 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_13 = { class: "s6" }
const _hoisted_14 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_15 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_16 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}

import { onMounted, ref } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserWalletUtilisation',
  props: {
    userId: {}
  },
  setup(__props: any) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const walletInfos = ref({
    solde: 0,
    solde_percent: 0,
    utilise: 0,
    utilise_percent: 0,
    dernier_decaissement: 0,
    dernier_decaissement_percent: 0,
    dernier_decaissement_date: null as string | null,
});
const walletLoading = ref(false);

onMounted(() => {
    loadWalletInfos();
});

async function loadWalletInfos() {
    if (!props.userId) return;
    walletLoading.value = true;
    try {
        const response = await axios.get(`/backoffice/users/${props.userId}/wallet_infos`);
        walletInfos.value = response.data || walletInfos.value;
    } catch (error: any) {
        console.error('Erreur chargement wallet infos:', error);
    } finally {
        walletLoading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Wallet / Utilisation </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Utilisation</span></button></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      (walletLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Chargement du wallet... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                _createTextVNode(" Solde ")
              ], -1)),
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(formatAmount)(walletInfos.value.solde)) + " F", 1),
              _createElementVNode("h5", _hoisted_7, _toDisplayString(walletInfos.value.solde_percent) + "%", 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                  style: _normalizeStyle(`width: ${walletInfos.value.solde_percent}%;`)
                }, _toDisplayString(walletInfos.value.solde_percent) + "% ", 5)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                _createElementVNode("div", { class: "circle-medium bg-purple" }),
                _createTextVNode(" Montant Utilisé ")
              ], -1)),
              _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(formatAmount)(walletInfos.value.utilise)) + " F", 1),
              _createElementVNode("h5", _hoisted_11, _toDisplayString(walletInfos.value.utilise_percent) + "%", 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                  style: _normalizeStyle(`width: ${walletInfos.value.utilise_percent}%;`)
                }, _toDisplayString(walletInfos.value.utilise_percent) + "% ", 5)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                _createTextVNode(" Dernier décaissement ")
              ], -1)),
              _createElementVNode("h1", _hoisted_14, _toDisplayString(_unref(formatAmount)(walletInfos.value.dernier_decaissement)) + " F", 1),
              _createElementVNode("h5", _hoisted_15, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "%", 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                  style: _normalizeStyle(`width: ${walletInfos.value.dernier_decaissement_percent}%;`)
                }, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "% ", 5)
              ])
            ])
          ]))
    ])
  ]))
}
}

})